import { DialogConfig } from "@/core/types";
import { createContext } from "react";

export const DialogContext = createContext<{
  openDialog: (dialogConfig: DialogConfig) => void;
  onDismiss: () => void;
  onClose: () => void;
  onSave: () => void;
}>(null!);
